<div class="min-h-screen flex items-center justify-center p-6" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);">
  <div class="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md p-10">
    <div class="text-center mb-6">
      <div class="flex justify-center mb-4 px-24">
        <img src="/Logo.png" alt="Logo" class="w-full h-auto object-contain">
      </div>
      <h1 class="text-3xl font-semibold text-gray-800 mb-2 m-0">Welcome Back</h1>
      <p class="text-base text-gray-500 m-0">Sign in to your account to continue</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="email" class="block text-sm font-medium text-gray-700">Email Address *</label>
        <input
          id="email"
          pInputText
          type="email"
          formControlName="email"
          placeholder="Enter your email"
          class="w-full"
          [class.ng-invalid]="emailError" />
          @if (emailError) {
            <div class="text-xs text-red-500 min-h-[16px]">{{ emailError }}</div>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="password" class="block text-sm font-medium text-gray-700">Password *</label>
          <p-password
            inputId="password"
            formControlName="password"
            placeholder="Enter your password"
            [toggleMask]="true"
            styleClass="w-full"
            inputStyleClass="w-full"
            [class.ng-invalid]="passwordError"
            [feedback]="false"
            promptLabel="Enter your password"
            weakLabel="Simple password"
            mediumLabel="Medium password"
            strongLabel="Complex password">
          </p-password>
          @if (passwordError) {
            <div class="text-xs text-red-500 min-h-[16px]">{{ passwordError }}</div>
          }
        </div>

        @if (errorMessage) {
          <div class="bg-red-50 text-red-600 p-3 rounded-lg text-sm border border-red-200">
            {{ errorMessage }}
          </div>
        }

        <div class="mt-2">
          <p-button
            type="submit"
            label="Sign In"
            [disabled]="loginForm.invalid"
            [loading]="isLoading"
            styleClass="w-full">
          </p-button>
        </div>
      </form>
    </div>
  </div>
